import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isCreateProjectPortfolioRequestFailure() {
      return getState().request.isFailure;
    },
    isCreateProjectPortfolioRequestPending() {
      return getState().request.isPending;
    },
    isCreateProjectPortfolioRequestSuccess() {
      return getState().request.isSuccessful;
    },
    getCreateProjectPortfolioError() {
      return getState().error;
    },
  };
}

export { createSelector };
